<app-header/>
<main class="h-full overflow-auto"
      [ngClass]="headerVariant === headerVariantEnum.SMALL ? 'lg:mt-header-spacing' : 'mt-header-spacing'">
  <div class="min-h-full h-full bg-secondary-100">
    <router-outlet>
    </router-outlet>
  </div>
</main>
<footer class="bg-transparent absolute bottom-0 w-full z-20">
  <div class="block lg:hidden">
    <app-navigation/>
  </div>
  <div class="hidden lg:block bg-secondary py-2 font-secondary text-white">
    <app-container>
      <div class="flex justify-end items-center text-sm">
        <a [routerLink]="'/app'" target="_blank" class="border-white pr-3 border-r">Download de app</a>
        <a [routerLink]="'/privacy-policy'" target="_blank" class="pl-3">Privacy policy & cookies</a>
      </div>
    </app-container>
  </div>
</footer>
<app-toast/>
